import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';

interface RoomBarProps {
  title: string;
  to?: string;
  meta?: string;
  introduction?: string | null;
  /** Leave the bottom open so the introduction can continue in the sliding column. */
  openBottom?: boolean;
  onNavigate?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export default function RoomBar({
  title,
  to,
  meta,
  introduction,
  openBottom = false,
  onNavigate,
}: RoomBarProps) {
  return (
    <header className={`bg-gray-50 border-t border-gray-200 ${openBottom ? '' : 'border-b'}`}>
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${openBottom ? 'pt-8' : 'py-8'}`}>
        {to ? (
          <Link
            to={to}
            onClick={onNavigate}
            className="inline-flex min-h-[44px] items-center text-xl font-semibold text-gray-900 hover:text-primary transition-colors"
          >
            {title}
          </Link>
        ) : (
          <h1 tabIndex={-1} className="text-3xl md:text-4xl font-bold text-gray-900 outline-none">{title}</h1>
        )}
        {meta ? <p className="mt-2 text-sm text-gray-600">{meta}</p> : null}
        {introduction ? (
          <p className="mt-3 text-lg text-gray-600 max-w-3xl">{introduction}</p>
        ) : null}
      </div>
    </header>
  );
}
